import * as React from "react"
const SvgTarea = (props) => (
  <svg
    className="anticon anticon-setting ant-menu-item-icon"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth={0}
    viewBox="0 0 24 24"

    version="1.0"
    width="17"
    height="17"
    strokeLinecap="square"
    strokeLinejoin="arcs"
>
    <path
      fill="currentColor"
      fillRule="evenodd"
      stroke="none"
      d="M10 1a1 1 0 0 0-.707.293l-6 6A1 1 0 0 0 3 8v12a3 3 0 0 0 3 3h1a1 1 0 1 0 0-2H6a1 1 0 0 1-1-1V9h5a1 1 0 0 0 1-1V3h7a1 1 0 0 1 1 1v3a1 1 0 1 0 2 0V4a3 3 0 0 0-3-3h-8ZM9 7H6.414L9 4.414V7Zm13.121 3.707a3 3 0 0 0-4.242 0l-1.68 1.68-4.906 4.906a.999.999 0 0 0-.263.465l-1 4a1 1 0 0 0 1.213 1.212l4-1a.999.999 0 0 0 .464-.263l4.849-4.848 1.737-1.738a3 3 0 0 0 0-4.242l-.172-.172Zm-3.814 2.4.986-.986a1 1 0 0 1 1.414 0l.172.172a1 1 0 0 1 0 1.414l-1.017 1.017-1.555-1.617Zm-1.415 1.415 1.556 1.616-3.96 3.959-2.114.529.529-2.115 3.99-3.99Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgTarea
